/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";

const MapWrapper = () => {
    const mapRef = React.useRef(null);
    React.useEffect(() => {
      let google = window.google;
      let map = mapRef.current;
      let lat = "40.748817";
      let lng = "-73.985428";
      const myLatlng = new google.maps.LatLng(lat, lng);
      const mapOptions = {
        zoom: 12,
        center: myLatlng,
        scrollwheel: false,
        zoomControl: true,
        styles: [
          {
            featureType: "administrative",
            elementType: "labels.text.fill",
            stylers: [{ color: "#444444" }],
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [{ color: "#f2f2f2" }],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [{ saturation: -100 }, { lightness: 45 }],
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [{ visibility: "simplified" }],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: [{ color: "#5e72e4" }, { visibility: "on" }],
          },
        ],
      };
  
      map = new google.maps.Map(map, mapOptions);
  
      const marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        animation: google.maps.Animation.DROP,
        title: "Light Bootstrap Dashboard PRO React!",
      });
  
      const contentString =
        '<div class="info-window-content"><h2>Light Bootstrap Dashboard PRO React</h2>' +
        "<p>A premium Admin for React-Bootstrap, Bootstrap, React, and React Hooks.</p></div>";
  
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
  
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }, []);
    return (
      <>
        <div
          style={{ height: `600px` }}
          className="map-canvas"
          id="map-canvas"
          ref={mapRef}
        ></div>
      </>
    );
  };

  export default MapWrapper;